import { render } from "./ItemCategories.vue?vue&type=template&id=2bfff4dd&scoped=true"
import script from "./ItemCategories.vue?vue&type=script&lang=js"
export * from "./ItemCategories.vue?vue&type=script&lang=js"

import "./ItemCategories.vue?vue&type=style&index=0&id=2bfff4dd&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bfff4dd"]])

export default __exports__